// JavaScript Document

// Scripts written by Jacob Bearce @ Weblinx, Inc.

import noUiSlider from "nouislider";
import wNumb from "wnumb";

const FIELDSETS = document.querySelectorAll(".product-filter__fieldset--range");

if (FIELDSETS.length > 0) {
    FIELDSETS.forEach((fieldset) => {
        const CHECKBOX  = fieldset.querySelector(".product-filter__input.input--checkbox");
        const RANGE     = fieldset.querySelector(".product-filter__nouislider");
        const INPUT_MIN = fieldset.querySelector("input[id$=_min]");
        const INPUT_MAX = fieldset.querySelector("input[id$=_max]");

        /**
         * Mark the range as disabled if the "all" checkbox is selected, or vice versa
         */
        CHECKBOX.addEventListener("change", () => {
            if (CHECKBOX.checked) {
                RANGE.parentElement.classList.add("input__container--disabled");
                INPUT_MIN.setAttribute("disabled", "disabled");
                INPUT_MAX.setAttribute("disabled", "disabled");
            } else {
                RANGE.parentElement.classList.remove("input__container--disabled");
                INPUT_MIN.removeAttribute("disabled");
                INPUT_MAX.removeAttribute("disabled");
            }
        });

        /**
         * Activate noUiSlider
         */
        noUiSlider.create(RANGE, {
            connect: true,
            format:  {
                to: (value) => {
                    return parseInt(value);
                },
                from: (value) => {
                    return parseInt(value);
                },
            },
            range:    {
                "min": parseInt(RANGE.dataset.rangeMin),
                "max": parseInt(RANGE.dataset.rangeMax),
            },
            start:    [
                parseInt(RANGE.dataset.valueMin),
                parseInt(RANGE.dataset.valueMax),
            ],
            step:     1,
            tooltips: [
                wNumb({
                    suffix: ` ${l10n.size_unit}`,
                }),
                wNumb({
                    suffix: ` ${l10n.size_unit}`,
                }),
            ],
        });

        RANGE.noUiSlider.on("change", () => {
            INPUT_MIN.setAttribute("value", RANGE.noUiSlider.get()[0]);
            INPUT_MAX.setAttribute("value", RANGE.noUiSlider.get()[1]);

            if ("createEvent" in document) {
                const EVENT = document.createEvent("HTMLEvents");
                EVENT.initEvent("change", false, true);
                INPUT_MIN.dispatchEvent(EVENT);
                INPUT_MAX.dispatchEvent(EVENT);
            } else {
                INPUT_MIN.fireEvent("onchange");
                INPUT_MAX.fireEvent("onchange");
            }

        });
    });
}
